'use strict';
exports.__esModule = true;
const color = require('./color');
const ratio = require('./ratio');
const typography = require('./typography');
/**
 * Change array to key/value object
 * @param {*} items
 * @param {string} prefix - Prepend to class name
 */
const convert = function (items, prefix) {
    if (Array.isArray(items)) {
        return Object.assign.apply(
            Object,
            [{}].concat(
                items.map(function (item) {
                    var _a;
                    var className = prefix ? `${prefix}-${item.key}` : `${item.key}`;
                    return (_a = {}), (_a[className] = item.value), _a;
                })
            )
        );
    }

    return items;
};
exports.convert = convert;

const assignDefault = function (value, other) {
    return Object.assign.apply(Object, [{}].concat({ default: value }, other));
};
exports.assignDefault = assignDefault;

const assignKeyPrefix = function (arr, prefix) {
    if (Array.isArray(arr)) {
        const newArray = [];
        arr.forEach(function (item) {
            const _a = Object.assign.apply(Object, [{}].concat(item));
            _a.key = `${prefix}-${item.key}`;
            newArray.push(_a);
        });

        return newArray;
    }

    return arr;
};
exports.assignKeyPrefix = assignKeyPrefix;

const PREFIX = {
    color: 'col',
    backgroundColor: 'bg-col',
    borderColor: 'b-col',
    button: 'button',
    ratio: 'ratio',
    fontFamily: 'font',
    fontWeight: 'fw',
    form: 'form'
};
exports.PREFIX = PREFIX;

// Config
exports.config = {
    // core
    breakpoint: {
        s: {
            width: 0, // in px
            base: 375, // in px
            limit: {
                min: 100,
                max: 15 // in %
            }
        },
        m: {
            width: 701, // in px
            base: 768, // in px
            limit: {
                min: 100,
                max: 15 // in %
            }
        },
        l: {
            width: 1101, // in px
            base: 1440, // in px
            limit: {
                min: 10,
                max: 0 // in %
            }
        },
        x: {
            width: 1501, // in px
            base: 1920, // in px
            limit: {
                min: 10,
                max: 0 // in %
            }
        }
    },
    size: {
        s: 1,
        m: 0.4,
        l: '5px',
        x: '5px'
    },
    // color
    color: convert(color.color),
    // layout
    layout: {
        width: '1280px'
    },
    // animation
    animation: {
        hideUp: {
            default: '30em',
            custom: []
        }
    },
    // background
    background: {
        color: assignDefault('white', convert(color.color))
    },
    // body
    body: {
        background: {
            color: 'white'
        },
        color: 'black',
        font: {
            family: typography.fontFamilyDefault,
            weight: typography.fontWeight.regular
        }
    },
    // border
    border: {
        radius: {
            default: 0,
            custom: []
        },
        color: assignDefault('black', convert(color.color)),
        width: {
            default: 1,
            custom: [2]
        }
    },
    // component
    component: {
        size: {
            default: '2.75em'
        }
    },
    // flex
    flex: {
        span: {
            max: 6
        },
        order: {
            max: 11
        }
    },
    // height
    height: {
        min: [],
        max: []
    },
    // grid
    grid: {
        columns: {
            default: 12,
            custom: []
        },
        gutter: {
            default: 4,
            custom: [],
            size: {}
        }
    },
    // margin
    margin: {
        min: 0,
        max: 4,
        custom: [6, 8]
    },
    // padding
    padding: {
        max: 4,
        custom: [6, 8]
    },
    // position
    position: {
        min: 0,
        max: 4,
        custom: [],
        index: {
            max: 10,
            custom: []
        }
    },
    // ratio
    ratio: convert(ratio.ratio),
    // typography
    typography: {
        fluid: 1, // 1 or 0
        size: {
            s: 4.26, // % of vw = 16px (375px)
            m: 2.08, // % of vw = 16px (768px)
            l: '16px',
            x: '16px'
        },
        ms: 1.125,
        font: {
            size: {
                base: 5,
                max: 21,
                custom: []
            },
            family: assignDefault(typography.fontFamilyDefault, convert(typography.fontFamily)),
            weight: convert(typography.fontWeight)
        },
        lineHeight: {
            1: '1.2em',
            2: '1.4em',
            3: '1.6em'
        },
        letterSpacing: {
            min: 0,
            max: 2,
            custom: []
        }
    },
    // width
    width: {
        min: [],
        max: []
    }
};
